//@ts-check
import { imagePath, hostname, imgify } from './data/misc';
// Edit this list and the navs shall change accordingly

/**
 * @typedef {{name:string,link:string}} menuitem
 * @typedef {{name:string,isMenu:true}} isMenuItem
 */
/**
 * Main navifation link
 * @type {(menuitem|isMenuItem)[]}
 */
export const navs = [
  { name: 'Home', link: '/' },
  { name: 'About Us', link: '/about' },
  { name: 'Events', link: '/events' },
  { name: 'Societies', isMenu: true },
  { name: 'Affinities', isMenu: true },
  { name: 'Membership', link: '/membership' },
  { name: 'Articles', link: '/articles' },
  { name: 'Login', link: '/login' },
];

/**
 * Buttons for Society Page
 * @type {menuitem[]}
 */
export const societyNav = [
  { name: 'Home', link: '/' },
  { name: 'About Us', link: '/about' },
  { name: 'Events', link: '/event' },
  { name: 'Exec Com', link: '/society' },
  { name: 'Login', link: '/login' },
];

/**
 * List of societies and links
 * @type {menuitem[]}
 */
export const societies = [
  { name: 'Computer Society', link: '/society/cs' },
  { name: 'Communications Society', link: '/society/comsoc' },
  { name: 'Power and Energy Society', link: '/society/pes' },
  { name: 'Signal Processing Society', link: '/society/sps' },
  { name: 'Antennas and Propagation Society', link: '/society/aps' },
  { name: 'Robotics and Automation Society', link: '/society/ras' },
  { name: 'Circuits and Systems Society', link: '/society/cas' },
  { name: 'Sensor Council', link: '/society/sc' },
  { name: 'Microwave Theory and Technology Society', link: '/society/mtts' },
  { name: 'Aerospace and Electronic Systems Society ', link: '/society/aess' },
];

/**
 * List of affinities and links
 * @type {menuitem[]}
 */
export const affinities = [
  {
    name: 'Special Interest Group on Humanitarian Technology',
    link: '/affinity/sight',
  },
  { name: 'Women in Engineering', link: '/affinity/wie' },
];

/**
 * Miscellaneous images
 */
export const images = {
  membership: {
    benefits: imagePath + '/membership/Benefits.jpeg',
    whyjoin: imagePath + '/membership/whyjoin.jpeg',
    step11: imagePath + '/membership/Membership_1.1.png',
    step12: imagePath + '/membership/Membership_1.2.png',
    step21: imagePath + '/membership/Membership_2.1.png',
    step31: imagePath + '/membership/Membership_3.1.png',
    step32: imagePath + '/membership/Membership_3.2.png',
    step33: imagePath + '/membership/Membership_3.3.png',
    step34: imagePath + '/membership/Membership_3.4.png',
    step35: imagePath + '/membership/Membership_3.5.png',
    step36: imagePath + '/membership/Membership_3.6.png',
    step37: imagePath + '/membership/Membership_3.7.png',
    step41: imagePath + '/membership/Membership_4.1.png',
    step42: imagePath + '/membership/Membership_4.2.png',
    step43: imagePath + '/membership/Membership_4.3.png',
    step51: imagePath + '/membership/Membership_5.1.jpeg',
    step52: imagePath + '/membership/Membership_5.2.jpeg',
    step61: imagePath + '/membership/Membership_6.1.png',
    benefit1: imagePath + '/membership/Benefit1.png',
    benefit2: imagePath + '/membership/Benefit2.png',
    benefit3: imagePath + '/membership/Benefit3.png',
    benefit4: imagePath + '/membership/Benefit4.png',
    benefit5: imagePath + '/membership/Benefit5.png',
    benefit6: imagePath + '/membership/Benefit6.png',
    whatSBOffers: imagePath + '/membership/WhatSBOffers.png',
    step111: imagePath + '/membership/Membership_1.11.png',
    step122: imagePath + '/membership/Membership_1.22.png',
    step511: imagePath + '/membership/Membership_5.11.jpg',
    step522: imagePath + '/membership/Membership_5.22.jpg',
  },
  devs: {
    ambu: imagePath + '/devs/Ambu_Karthik.jpg',
    bain: imagePath + '/devs/Atreya_Bain.png',
    chirag: imagePath + '/devs/Chirag_Bapat.jpg',
    risha: imagePath + '/devs/Risha_Dassi.jpg',
    vishal: imagePath + '/devs/Vishal_M.jpeg',
    akshara: imagePath + '/devs/Akshara_Udupa.jpg',
    sannidhi: imagePath + '/devs/sannidhi.jpg',
    mayur: imagePath + '/devs/mayur_s_chittaragi.jpg',
    naveen: imagePath + '/devs/naveen.jpeg',
    prajwal: imagePath + '/devs/pp.jpg',
    jahnavi: imagePath + '/devs/jahnavi.jpg',
    sundar: imagePath + '/devs/sundarakrishnan.jpeg',
    ayush: imagePath + '/devs/Ayush Ratan Web Team .jpg',
    chiragJ: imagePath + '/devs/Chirag Kumar Jaiswal Web team .jpg',
    tejas: imagePath + '/devs/TejasPattarWebTeam.jpg',
  },
  logos: {
    ieee_aps: imagePath + '/logos/ieee_APS.png',
    ieee_black: imagePath + '/logos/ieee_black.png',
    ieee_blue_jpg: imagePath + '/logos/ieee_blue.jpg',
    ieee_bng: imagePath + '/logos/ieee_bng.png',
    ieee_blue_png: imagePath + '/logos/ieee_blue.png',
    ieee_compsoc_black: imagePath + '/logos/ieee_computer_black.png',
    ieee_compsoc_color: imagePath + '/logos/ieee_computer_color.png',
    ieee_compsoc_white: imagePath + '/logos/ieee_computer_white.png',
    ieee_pes: imagePath + '/logos/ieee_pes.jpg',
    ieee_rvce_new_black: imagePath + '/logos/ieee_rvce_new_black.png',
    ieee_rvce_new_black_big: imagePath + '/logos/ieee_rvce_new_black_big.png',
    ieee_rvce_new_blue: imagePath + '/logos/ieee_rvce_new_blue.png',
    ieee_rvce_new_blue_big: imagePath + '/logos/ieee_rvce_new_blue_big.png',
    ieee_rvce_new_white: imagePath + '/logos/ieee_rvce_new_white.png',
    ieee_rvce_new_white_big: imagePath + '/logos/ieee_rvce_new_white_big.png',
    ieee_rvce_black: imagePath + '/logos/ieee_rvce_black.png',
    ieee_rvce_white: imagePath + '/logos/ieee_rvce_white.png',
    ieee_rvce_jpg: imagePath + '/logos/ieee_rvce.jpg',
    ieee_sight: imagePath + '/logos/ieee_sight.png',
    ieee_sps: imagePath + '/logos/ieee_sps.jpg',
    ieee_tag_black: imagePath + '/logos/ieee_tag_black.png',
    ieee_tag_blue: imagePath + '/logos/ieee_tag_blue.png',
    ieee_tag_white: imagePath + '/logos/ieee_tag_white.png',
    ieee_white: imagePath + '/logos/ieee_white.png',
    ieee_wie: imagePath + '/logos/ieee_wie.png',
    rv_caption: imagePath + '/logos/rv_caption.png',
    rv_letter_footer: imagePath + '/logos/rv_letter_footer.png',
    rvce: imagePath + '/logos/rvce_logo.png',
  },
  landing: {
    aps: imagePath + '/landing/aps.png',
    compsoc: imagePath + '/landing/compsoc.png',
    comsoc: imagePath + '/landing/comsoc.png',
    pes: imagePath + '/landing/pes.png',
    ras: imagePath + '/landing/ras.png',
    sight: imagePath + '/landing/sight.png',
    sps: imagePath + '/landing/sps.png',
    wie: imagePath + '/landing/wie.png',
    mainBlack: imagePath + '/landing/MainBlack.png',
    mainWhite: imagePath + '/landing/MainWhite.png',
    cas: imagePath + '/landing/cas.png',
    sc: imagePath + '/landing/sc.png',
    mtts: imagePath + '/landing/mtts.png',
    aess: imagePath + '/landing/aess.png',
  },
};

/** Map of socs and affs with ecat */
export const ecats = {
  main: 0,
  compsoc: 1,
  comsoc: 2,
  pes: 3,
  aps: 4,
  sps: 5,
  ras: 6,
  wie: 7,
  sight: 8,
  cas: 9,
  sc: 10,
  mtts: 11,
  aess: 12,
};

/** Execom details */
export const execom = {
  main: [
    {
      name: 'Dr. Usha J',
      position: 'Branch Counselor',
      image: 'https://rvce.rveducationalinstitutions.com/department/wp-content/uploads/2025/07/USHA-J-1-scaled.jpg',
    },
    {
      name: 'Nishant V H',
      position: 'Chair',
      image: imagePath + '/execom/main/Nishant Hegde - Chair.jpeg',
    },
    {
      name: 'Pranav V Jambur',
      position: 'Vice Chair',
      image: imagePath + '/execom/main/Pranav V Jambur - Vice Chair.jpg',
    },
    {
      name: 'Vijayalaxmi Ashok Patil',
      position: 'Secretary',
      image: imagePath + '/execom/main/Vijayalaxmi-Secretary.jpg',
    },
    {
      name: 'Shreekara H',
      position: 'Joint Secratary',
      image: imagePath + '/execom/main/Shreekara H - Joint Secretary .jpg',
    },
    {
      name: 'Manodnya Korishetty',
      position: 'Treasurer',
      image: imagePath + '/execom/main/Manodnya Korishetty - Treasurer.jpg',
    },
    {
      name: 'Samanvitha L',
      position: 'Joint Treasurer',
      image: imagePath + '/execom/main/SamanvithaL-JointTreasurer.jpg',
    },

    {
      name: 'Sathish Dath D S',
      position: 'Webmaster',
      image: imagePath + '/execom/main/Sathish Dath - WebMaster.jpg',
    },
    {
      name: 'Hitarth Mehra',
      position: 'Design Lead',
      image: imagePath + '/execom/main/Hitarth Mehra- Design Lead.JPG', //to be changed
    },
    {
      name: 'Yadamreddy Navaneeth',
      position: 'Design Lead',
      image: imagePath + '/execom/main/YadamreddyNavaneeth-DesignLead.png', //to be changed
    },
    {
      name: 'Kavin Krishnan C',
      position: 'MDC Chair',
      image: imagePath + '/execom/mdc/KavinKrishnanC_MDCChair.jpg', //to be changed
    },
    {
      name: 'Pratham G Bhat',
      position: 'MDC Secretary',
      image: imagePath + '/execom/mdc/Pratham G Bhat - MDC Secretary.jpg', //to be changed
    },
    {
      name: 'Suneesh Bare',
      position: 'MDC Secretary',
      image: imagePath + '/execom/mdc/Suneesh Bare - MDC Secretary.jpeg', //to be changed
    },
  ],
  aps: [
    {
      name: 'Dr. Ramavenkateswaran N',
      position: 'Faculty Advisor',
      image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/RAMAVENKATESWARAN-N-1-scaled.jpg',
    },
    {
      name: 'Vibhashree Vasuki',
      position: 'Chair',
      image: imagePath + '/execom/aps/Vibhashree Vasuki - CHAIR.jpeg',
    },
    {
      name: 'Manav Verma',
      position: 'Secretary',
      image: imagePath + '/execom/aps/Manav_Verma-Secretary.jpeg',
    },
    {
      name: 'Mahak',
      position: 'Treasurer',
      image: imagePath + '/execom/aps/Mahak-Treasurer.jpeg',
    },
  ],
  compsoc: [
    {
      name: 'Dr. Jyoti Shetty',
      position: 'Faculty Advisor',
      image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/JYOTI-SHETTY-1-scaled.jpg',
    },
    {
      name: 'Tanisha Bhide',
      position: 'Chair',
      image: imagePath + '/execom/compsoc/Tanisha Bhide-Chair.jpg',
    },
    {
      name: 'Sudeep Xavier Roche',
      position: 'Vice Chair',
      image: imagePath + '/execom/compsoc/Sudeep_Xavier_Roche-Vice_Chair.jpg',
    },
    {
      name: 'Megha N Iyer',
      position: 'Secretary',
      image: imagePath + '/execom/compsoc/Megha_N_Iyer-Secretary-CompSoc.jpeg',
    },
    {
      name: 'Vikram S Iyengar',
      position: 'Treasurer',
      image: imagePath + '/execom/compsoc/Vikram S Iyengar- Treasurer.jpg',
    },
  ],
  comsoc: [
    {
      name: 'Dr. Nethravati',
      position: 'Faculty Advisor',
      image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/NETRAVATHI-S-1-scaled.jpg',
    },
    {
      name: 'Trisha Bhattacharya',
      position: 'Chair',
      image: imagePath + '/execom/comsoc/Trisha Bhattacharya - Comsoc Chair.jpeg',
    },
    {
      name: 'Hardik G D',
      position: 'Vice Chair',
      image: imagePath + '/execom/comsoc/Hardik Gowdra-Co-Chair .jpg',
    },
    {
      name: 'Anup P Kothari',
      position: 'Secretary',
      image: imagePath + '/execom/comsoc/Anup P Kothari - Secratary.jpg',
    },
    {
      name: 'Anurag',
      position: 'Treasurer',
      image: imagePath + '/execom/comsoc/Anurag-treasurer.jpg',
    },
  ],
  pes: [
    {
      name: 'Prof. SG Srivani',
      position: 'Faculty Advisor',
      image: 'https://media.licdn.com/dms/image/v2/D5603AQENg1TB1F-y2A/profile-displayphoto-shrink_800_800/B56ZZ2Z07jHgAk-/0/1745743204494?e=1784160000&v=beta&t=jGZhECQnJiGBymywePUwjW1bO7i4HK_zxR5QBioHSn0',
    },
    {
      name: 'Pranav P Kamath',
      position: 'Chair',
      image: imagePath + '/execom/pes/Pranav P Kamath-Chair.jpg',
    },
    {
      name: 'Priyanka N Uday',
      position: 'Vice Chair',
      image: imagePath + '/execom/pes/Priyanka N Uday-Vice Chair.jpeg',
    },
    {
      name: 'Akshat Raj',
      position: 'Secretary',
      image: imagePath + '/execom/pes/Akshat Raj --Secretary.png',
    },
    {
      name: 'Parth Rathi',
      position: 'Joint Secretary',
      image: imagePath + '/execom/pes/Parth Rathi-Joint Secretary.png',
    },
    {
      name: 'Satvik B C',
      position: 'Treasurer',
      image: imagePath + '/execom/pes/Satvik B C-Treasurer.png',
    },
  ],
  sps: [
    {
      name: 'Dr. Saraswathi K',
      position: 'Faculty Advisor',
      image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/SARASWATHI-K-1-scaled.jpg',
    },
    {
      name: 'Vrinda V Katti',
      position: 'Chair',
      image: imagePath + '/execom/sps/VRINDA V KATTI - CHAIR.jpg',
    },
    {
      name: 'V Megha',
      position: 'Secretary',
      image: imagePath + '/execom/sps/V Megha.jpg',
    },
    {
      name: 'Sughosha Rao R',
      position: 'Treasurer',
      image: imagePath + '/execom/sps/SughoshaRaoR-Treasures.png',
    },
  ],
  wie: [
    {
      name: 'Dr Ashwini',
      position: 'Faculty Advisor',
      image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/ASHWINI-K-B-ISE-scaled.jpg',
    },
    {
      name: 'Chaitali Jain ',
      position: 'Chair',
      image: imagePath + '/execom/wie/Chaitali -  Chair.JPG',
    },
    {
      name: 'Jahnavi P',
      position: 'Secretary',
      image: imagePath + '/execom/wie/Jahnavi- Secretary .HEIC',
    },
    {
      name: 'Khushi N',
      position: 'Treasurer',
      image: imagePath + '/execom/wie/Khushi N-Treasurer.jpg',
    },
  ],
  ras: [
    {
      name: 'Dr. Rohini S Hallikar',
      position: 'Faculty Advisor',
      image: imagePath + '/execom/ras/Rohini S Hallikar - Faculty Advisor.jpg',
    },
    {
      name: 'Y Sanjana',
      position: 'Chair',
      image: imagePath + '/execom/ras/Y Sanjana_Chair.jpeg',
    },
    {
      name: 'D Aaditya',
      position: 'Secretary',
      image: imagePath + '/execom/ras/D.Aaditya secretary.jpg',
    },
    {
      name: 'Vartika Mrigwani',
      position: 'Treasurer',
      image: imagePath + '/execom/ras/Vartika_Treasurer.jpeg',
    },
  ],
  sight: [
    {
      name: 'Dr. Andhe Dharani',
      position: 'Faculty Advisor',
      image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/ANDHE-DHARANI-1-scaled.jpg',
    },
    {
      name: 'Gaurav Kumar',
      position: 'Chair',
      image: imagePath + '/execom/sight/lalith_kishore.jpg',
    },
    {
      name: 'Anirudha M',
      position: 'Secretary',
      image: imagePath + '/execom/sight/nandan_chebbi.jpg',
    },
    {
      name: 'Kulkarni Aditya Vivek',
      position: 'Treasurer',
      image: imagePath + '/execom/sight/Kulkarni Aditya - Treasurer.jpeg',
    },
  ],
  cas: [
    {
      name: 'Dr. Shylashree N',
      position: 'Faculty Advisor',
      image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/SHYLASHREE-N-1-scaled.jpg',
    },
    {
      name: 'Tharun Reddy P',
      position: 'Chair',
      image: imagePath + '/execom/cas/Tharun Reddy P -chair.jpg',
    },
    {
      name: 'Yash C Kerure',
      position: 'Vice Chair',
      image: imagePath + '/execom/cas/Yash C Kerure - Vice Chair.jpg',
    },
    {
      name: 'Tanvi Prasad Kulkarni',
      position: 'Secretary',
      image: imagePath + '/execom/cas/Tanvi Prasad Kulkarni - Secretary.jpg',
    },
    {
      name: 'Atharv Aniyappanavar',
      position: 'Treasurer',
      image: '',
    },
    {
      name: 'Aditi Rupangundi',
      position: 'Webmaster',
      image: '',
    },
  ],
  sc: [
    {
      name: 'Dr. Ravishankar Holla',
      position: 'Faculty Advisor',
      image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/RAVISHANKAR-HOLLA-1-scaled.jpg',
    },
    {
      name: 'Vikas T',
      position: 'Chair',
      image: imagePath + '/execom/sc/Vikas T Chair.png',
    },
    {
      name: 'Snigdha Raj',
      position: 'Secretary',
      image: imagePath + '/execom/sc/Snigdha Raj_Secretary.jpeg',
    },
    {
      name: 'Suchitha M',
      position: 'Treasurer',
      image: imagePath + '/execom/sc/Suchitha M Treasurer.jpeg',
    },
  ],

  aess: [
    {
      name: 'Dr. Mahesh A',
      position: 'Faculty Advisor',
      image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/MAHESH-A-1-2-scaled.jpg',
    },
    {
      name: 'Shambhavi Shukla',
      position: 'Chair',
      image: imagePath + '/execom/aess/2026/Shambhavi Shukla-Chair.jpg',
    },
    {
      name: 'Shanthosh K V',
      position: 'Vice Chair',
      image: imagePath + '/execom/aess/2026/Shanthosh KV - Vice Chair.jpeg',
    },
    {
      name: 'Sarvika Raju Chamarthy',
      position: 'Secretary',
      image: imagePath + '/execom/aess/2026/Sarvika Raju Chamarthy - Secretary.jpg',
    },
    {
      name: 'Nitesh S',
      position: 'Treasurer',
      image: imagePath + '/execom/aess/2026/Nitesh.S-Treasurer.jpg',
    },
  ],
  mtts: [
    {
      name: 'Dr. Shanthi P',
      position: 'Faculty Advisor',
      image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/SHANTHI-P-ETE-1-scaled.jpg',
    },
    {
      name: 'Shreya S',
      position: 'Chair',
      image: '',
    },
    {
      name: 'Siddharth Ghosh',
      position: 'Secretary',
      image: '',
    },
    {
      name: 'Pruthvi Kiran',
      position: 'Treasurer',
      image: '',
    },
  ],
};

/** Alumni execom.
 * _image_ is optional, placeholder will be added in automatically
 */
export const alumni = {
  main: {
    2025: [
      {
        name: 'Dr. Shylashree N',
        position: 'Branch Counselor',
        image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/SHYLASHREE-N-1-scaled.jpg',
      },
      {
        name: 'Harini G Iyar',
        position: 'Chair',
        image: imagePath + '/alumni/2025/main/Harini_Chair.jpg',
      },
      {
        name: 'Ishan Varun',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2025/main/Ishan Varun(VC).jpg',
      },
      {
        name: 'Akshara Sridhara',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/main/Akshara Sridhara, Secretary.jpg',
      },
      {
        name: 'Tanmaya W M',
        position: 'Joint Secratary',
        image: imagePath + '/alumni/2025/main/Tanmaya WM- joint secretary.jpg',
      },
      {
        name: 'Chirag V',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/main/Chirag V Treasurer.jpg',
      },
      {
        name: 'Manodanya Korishetty',
        position: 'Joint Treasurer',
        image: imagePath + '/alumni/2025/main/Manodnya Korishetty-joint treasurer .jpg',
      },
      {
        name: 'Ayush Ratan',
        position: 'Webmaster',
        image: imagePath + '/alumni/2025/main/AyushRatan_WebMaster.jpeg',
      },
      {
        name: 'Vijayalaxmi Ashok Patil',
        position: 'Design Lead',
        image: imagePath + '/alumni/2025/main/Vijaylakshmi_design.jpeg', //to be changed
      },
      {
        name: 'Saara Unnathi R',
        position: 'Design Lead',
        image: imagePath + '/alumni/2025/main/SaaraUnnathi_design.png', //to be changed
      },
    ],
    2024: [
      {
        name: 'Dr. Shylashree N',
        position: 'Branch Counselor',
        image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/SHYLASHREE-N-1-scaled.jpg',
      },
      {
        name: 'Sreekar Mulukutla',
        position: 'Chair',
        image: imagePath + '/alumni/2024/main/Chair.jpeg',
      },
      {
        name: 'Vedram S',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2024/main/vedram.jpg',
      },
      {
        name: 'Mayur G Parvatikar',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/main/Mayur G Parvatikar-Secretary.jpg',
      },
      {
        name: 'Jahnavi M Math',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/main/Jahnavi M Math_Treasurer .JPG',
      },
      {
        name: 'Harini G Iyar',
        position: 'Joint Treasurer',
        image: imagePath + '/alumni/2024/main/Harini G Iyar- Joint Treasurer.jpeg',
      },

      {
        name: 'Sundarakrishnan N',
        position: 'Webmaster',
        image: imagePath + '/alumni/2024/main/sundarakrishnan.jpeg',
      },
      {
        name: 'Amrit Raj',
        position: 'Design Lead',
        image: imagePath + '/alumni/2024/main/AmritRaj.jpg', //to be changed
      },
    ],
    2023: [
      {
        name: 'Dr. Mahesh A',
        position: 'Branch Counselor',
        image: imagePath + '/alumni/2024/main/mahesh_sir.jpg',
      },
      {
        name: 'Dhanush Prabhakar ',
        position: 'Chair',
        image: imagePath + '/alumni/2024/main/dhanush_prabhakar.jpg',
      },
      {
        name: 'Ritesh Gandhi',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2024/main/ritesh.jpeg',
      },
      {
        name: 'Nisarga V',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/main/nisarga.jpg',
      },
      {
        name: 'Lathangi N',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/main/lathangi_n.jpg',
      },
      {
        name: 'Mayur S Chittaragi',
        position: 'Webmaster',
        image: imagePath + '/alumni/2024/main/mayur_s_chittaragi.jpg',
      },
      {
        name: 'Adarsh V',
        position: 'Social Media Head',
        image: imagePath + '/alumni/2024/socialMedia/adarsh.jpeg', //to be changed
      },
    ],
    2022: [
      {
        name: 'Dr. Mahesh A',
        position: 'Branch Counselor',
        image: imagePath + '/alumni/2022/main/mahesh_sir.jpg',
      },
      {
        name: 'Shashank Dhavala',
        position: 'Chair',
        image: imagePath + '/alumni/2022/main/shashank.jpeg',
      },
      {
        name: 'Anushka Subramanian',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2022/main/anushka.jpg',
      },
      {
        name: 'Jahnavi Urs',
        position: 'Secretary',
        image: imagePath + '/alumni/2022/main/jahnavi.jpg',
      },
      {
        name: 'Vivek Kumar',
        position: 'Treasurer',
        image: imagePath + '/alumni/2022/main/vivek.jpg',
      },
      {
        name: 'Prajwal P',
        position: 'Webmaster',
        image: imagePath + '/alumni/2022/main/prajwal.PNG',
      },
    ],
    2021: [
      {
        name: 'Dr. M Uttara Kumari',
        position: 'Branch Counselor',
        image: imagePath + '/alumni/2021/main/muk_maam.jpg',
      },
      {
        name: 'Risha Dassi',
        position: 'Chair',
        image: imagePath + '/alumni/2021/main/risha.jpg',
      },
      {
        name: 'Kashish Malhotra',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2021/main/kashish.jpg',
      },
      {
        name: 'Deeraj DS',
        position: 'Secretary',
        image: imagePath + '/alumni/2021/main/deeraj.jpg',
      },
      {
        name: 'Chirag Bapat',
        position: 'Treasurer',
        image: imagePath + '/alumni/2021/main/chirag.jpg',
      },
      {
        name: 'Atreya Bain',
        position: 'Webmaster',
        image: imagePath + '/alumni/2021/main/atreya.png',
      },
      {
        name: 'Saraansh Agarwal',
        position: 'Editor in Chief',
        image: imagePath + '/alumni/2021/main/saraansh.jpg',
      },
    ],
    2020: [
      {
        name: 'Dr. M Uttara Kumari',
        position: 'Branch Counselor',
        image: imagePath + '/alumni/2020/main/muk_maam.jpg',
      },
      {
        name: 'SJ Ruthvik',
        position: 'Chair',
        image: imagePath + '/alumni/2020/main/ruthvik.jpg',
      },
      {
        name: 'Srinivas Prabhu',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2020/main/srini.jpg',
      },
      {
        name: 'Deekshith Nayak',
        position: 'Secretary',
        image: imagePath + '/alumni/2020/main/deekshith.jpg',
      },
      {
        name: 'Prajwal S Telkar',
        position: 'Treasurer',
        image: imagePath + '/alumni/2020/main/prajwal.jpg',
      },
      {
        name: 'Siddarth Sai Amruth Yetikuri',
        position: 'Editor in Chief',
        image: imagePath + '/alumni/2020/main/sidsai.jpg',
      },
      { name: 'Nagesh B', position: 'MDC Chair' },
    ],
    2019: [
      {
        name: 'Dr. M Uttara Kumari',
        position: 'Branch Counselor',
        image: imagePath + '/alumni/2020/main/muk_maam.jpg',
      },
      {
        name: 'Akshathaa Vydula',
        position: 'Chair',
        image: imagePath + '/alumni/2019/main/akonakon.png',
      },
      { name: 'Disha Hegde', position: 'Vice Chair' },
      {
        name: 'Mujavar Mohammad Ashtaq',
        position: 'Secretary',
        image: imagePath + '/alumni/2019/main/ashtaq.jpeg',
      },
      { name: 'Varun Elango', position: 'Treasurer' },
      { name: 'Shravan Sridhar', position: 'Webmaster' },
      {
        name: 'Varun T Naik',
        position: 'Publicity Head',
        image: imagePath + '/alumni/2019/main/varunt.jpeg',
      },
    ],
    2018: [
      {
        name: 'Dr. M Uttara Kumari',
        position: 'Branch Counselor',
        image: imagePath + '/alumni/2018/main/muk_maam.jpg',
      },
      {
        name: 'PVS Rohith',
        position: 'Chair',
        image: imagePath + '/alumni/2018/main/rohith.jpg',
      },
      {
        name: 'Aditya Madhavan',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2018/main/aditya.jpg',
      },
      {
        name: 'Adithya Thonse',
        position: 'Secretary',
        image: imagePath + '/alumni/2018/main/adithya.jpg',
      },
      {
        name: 'Tejasrikumar Kori',
        position: 'Treasurer',
        image: imagePath + '/alumni/2018/main/teja.jpg',
      },
    ],
  },
  aps: {
    2025: [
      {
        name: 'Prof. Shanti P',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/aps/shanthi_maam.jpg',
      },
      {
        name: 'Vrinda. V. Patil',
        position: 'Chair',
        image: imagePath + '/alumni/2025/aps/Chair - Vrinda V Patil.jpg',
      },
      {
        name: 'Srujan B N',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/aps/Secretary - Srujan B N.jpg',
      },
      {
        name: 'Srujan Prasad',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/aps/Treasurer - Srujan Prasad .jpg',
      },
    ],
    2024: [
      {
        name: 'Prof. Shanti P',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/aps/shanthi_maam.jpg',
      },
      {
        name: 'V Dheeraj',
        position: 'Chair',
        image: imagePath + '/alumni/2024/aps/Dheeraj V.jpg',
      },
      {
        name: 'Vrinda V Patil',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/aps/Vrinda V Patil.jpg',
      },
      {
        name: 'Anish Shaw',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/aps/Anish_Shaw.jpg.JPG',
      },
    ],
    2023: [
      {
        name: 'Prof. Shanti P',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/aps/shanthi_maam.jpg',
      },
      {
        name: 'Amogh G',
        position: 'Chair',
        image: imagePath + '/alumni/2023/aps/Amogh G.jpg',
      },
      {
        name: 'Anusha Khot',
        position: 'Secretary',
        image: imagePath + '/alumni/2023/aps/Anusha Khot.jpg',
      },
      {
        name: 'Dheeraj G',
        position: 'Treasurer',
        image: imagePath + '/alumni/2023/aps/Dheeraj G.jpg',
      },
    ],
    2022: [
      {
        name: 'Dr. Mahesh A',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2022/aps/mahesh_sir.jpg',
      },
      {
        name: 'Narsepalli Pradyumna',
        position: 'Chair',
        image: imagePath + '/alumni/2022/aps/pradumyna.jpeg',
      },
      {
        name: 'Amogh G',
        position: 'Secretary',
        image: imagePath + '/alumni/2022/aps/Amough.jpeg',
      },
      {
        name: 'Dheeraj G',
        position: 'Treasurer',
        image: imagePath + '/alumni/2022/aps/Dheeraj.jpeg',
      },
    ],
    2021: [
      {
        name: 'Dr. Mahesh A',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2021/aps/mahesh_sir.jpg',
      },
      {
        name: 'Rahul Chikkodi',
        position: 'Chair',
        image: imagePath + '/alumni/2021/aps/rahul.jpg',
      },
      {
        name: 'Aravind Anant Bhat',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2021/aps/aravind.jpg',
      },
      {
        name: 'Pratap Vangol',
        position: 'Secretary',
        image: imagePath + '/alumni/2021/aps/pratap.jpg',
      },
      {
        name: 'Rohini G Bhatkoorse',
        position: 'Treasurer',
        image: imagePath + '/alumni/2021/aps/rohini.jpg',
      },
    ],
    2020: [
      {
        name: 'Dr. Mahesh A',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2020/aps/mahesh_sir.jpg',
      },
      {
        name: 'Rahul Chikkodi',
        position: 'Chair',
        image: imagePath + '/alumni/2020/aps/rahul.jpg',
      },
      {
        name: 'Pratap Vangol',
        position: 'Secretary',
        image: imagePath + '/alumni/2020/aps/pratap.jpg',
      },
    ],
  },
  compsoc: {
    2025: [
      {
        name: 'Dr. Ashok Kumar AR',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/compsoc/ashok_sir.jpg',
      },
      {
        name: 'Samkit Samsukha',
        position: 'Chair',
        image: imagePath + '/alumni/2025/compsoc/Chair - Samkit Samsukha.jpg',
      },
      {
        name: 'Monal Rai',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2025/compsoc/Vice Chair- Monal Rai .jpg',
      },
      {
        name: 'Pranav V Jambur',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/compsoc/Joint Secretary - Pranav V Jambur.jpg',
      },
      {
        name: 'Sampada G Kulkarni',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/compsoc/Treasurer  -  Sampada G Kulkarni.jpeg',
      },
    ],
    2024: [
      {
        name: 'Dr. Ashok Kumar AR',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/compsoc/ashok_sir.jpg',
      },
      {
        name: 'Likhith',
        position: 'Chair',
        image: imagePath + '/alumni/2024/compsoc/Likhith- Chair.jpg',
      },
      {
        name: 'Sravya D',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2024/compsoc/Sravya D-Vice Chair.jpg',
      },
      {
        name: 'Vibhav Simha',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/compsoc/Vibhav Simha - Secretary .jpg',
      },
      {
        name: 'Ganesh Naik',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/compsoc/Ganesh Naik - Treasurer.jpg',
      },
    ],
    2023: [
      {
        name: 'Dr. Ashok Kumar AR',
        position: 'Faculty Advisor',
        image: imagePath + '/execom/compsoc/ashok_sir.jpg',
      },
      {
        name: 'Prajwal M Pawar',
        position: 'Chair',
        image: imagePath + '/execom/compsoc/prajwal_pawar.jpg',
      },
      {
        name: 'Likhith ',
        position: 'Vice Chair',
        image: imagePath + '/execom/compsoc/likhith.jpg',
      },
      {
        name: 'Jayanth C',
        position: 'Joint Secretary',
        image: imagePath + '/execom/compsoc/jayanth_c.jpg',
      },
      {
        name: 'Sneha P.M',
        position: 'Joint Secretary',
        image: imagePath + '/execom/compsoc/sneha_p_m.jpg',
      },
      {
        name: 'Joshua Elias Alva',
        position: 'Treasurer',
        image: imagePath + '/execom/compsoc/joshua.jpg',
      },
    ],
    2022: [
      {
        name: 'Dr. Ashok Kumar AR',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2022/compsoc/ashok_sir.jpg',
      },
      {
        name: 'Shubhaprada K P',
        position: 'Chair',
        image: imagePath + '/alumni/2022/compsoc/ShubhaPrada.jpeg',
      },
      {
        name: 'Prajwal P',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2022/compsoc/prajwal.PNG',
      },
      {
        name: 'Malavika Hariprasad ',
        position: 'Secretary',
        image: imagePath + '/alumni/2022/compsoc/Malavika_HariPrasad.jpg',
      },
      {
        name: 'Sonia Singh B',
        position: 'Treasurer',
        image: imagePath + '/alumni/2022/compsoc/Sonia_Singh.jpeg',
      },
    ],
    2021: [
      {
        name: 'Dr. Ashok Kumar AR',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2021/compsoc/ashok_sir.jpg',
      },
      {
        name: 'Akshara Udupa',
        position: 'Chair',
        image: imagePath + '/alumni/2021/compsoc/akshara.jpg',
      },
      {
        name: 'Vishal M',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2021/compsoc/vishal.jpg',
      },
      {
        name: 'Shashank Dhavalla',
        position: 'Secretary',
        image: imagePath + '/alumni/2021/compsoc/shashank.jpg',
      },
      {
        name: 'Namya LG',
        position: 'Treasurer',
        image: imagePath + '/alumni/2021/compsoc/namya.jpg',
      },
    ],
    2020: [
      {
        name: 'Risha Dassi',
        position: 'Chair',
        image: imagePath + '/alumni/2020/compsoc/risha.jpg',
      },
      {
        name: 'Nischal J',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2020/compsoc/nischal.jpg',
      },
      {
        name: 'Nikitha Srikanth',
        position: 'Secretary',
        image: imagePath + '/alumni/2020/compsoc/niks.jpg',
      },
      {
        name: 'Chirag Bapat',
        position: 'Treasurer',
        image: imagePath + '/alumni/2020/compsoc/chirag.jpg',
      },
    ],
  },
  comsoc: {
    2025: [
      {
        name: 'Dr. Jayanthi',
        position: 'Faculty Advisor',
        image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/JAYANTHI-P-N-1-scaled.jpg',
      },
      {
        name: 'Preeti yadav',
        position: 'Chair',
        image: imagePath + '/alumni/2025/comsoc/Preeti.JPG',
      },
      {
        name: 'Rakshita Basarakod',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2025/comsoc/Rakshita Basarakod.png',
      },
      {
        name: 'Hardik G D',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/comsoc/Hardik.jpg',
      },
      {
        name: 'Piyush Singh Patial',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/comsoc/Piyush Singh.jpg',
      },
    ],
    2024: [
      {
        name: 'Dr. Jayanthi',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/comsoc/p_n_jayanti.jpg',
      },
      {
        name: 'Pradyumna S Athreya',
        position: 'Chair',
        image: imagePath + '/alumni/2024/comsoc/Pradyumna.jpg',
      },
      {
        name: 'Pavan Kumar C Banasode',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2024/comsoc/Pavan Kumar C Banasode - Vice Chair.jpg',
      },
      {
        name: 'Chetan Badiger ',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/comsoc/chetan.jpg',
      },
      {
        name: 'Preeti',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/comsoc/Preeti-Treasurer.jpg',
      },
    ],
    2023: [
      {
        name: 'Dr. Jayanthi',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2023/comsoc/p_n_jayanti.jpg',
      },
      {
        name: 'Shamanth S Bhat',
        position: 'Chair',
        image: imagePath + '/alumni/2023/comsoc/Shamanth_S_Bhat.jpg',
      },
      {
        name: 'Pradyumna S Athreya',
        position: 'Secretary',
        image: imagePath + '/alumni/2023/comsoc/pradyumna_s_athreya.jpg',
      },
      {
        name: 'Chethan S Badiger',
        position: 'Treasurer',
        image: imagePath + '/alumni/2023/comsoc/chetan.jpg',
      },
    ],
    2022: [
      {
        name: 'Dr. Shushrutha KS',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2022/comsoc/shushrutha_sir.jpg',
      },
      {
        name: 'Shamanth S Bhat',
        position: 'Chair',
        image: imagePath + '/alumni/2022/comsoc/Shamanth_S_Bhat.jpg',
      },
      {
        name: 'Dhanush Prabhakar',
        position: 'Secretary',
        image: imagePath + '/alumni/2022/comsoc/Dhanush.jpeg',
      },
      {
        name: 'Shreehitha MU',
        position: 'Treasurer',
        image: imagePath + '/alumni/2022/comsoc/shreehitha.jpg',
      },
    ],
    2021: [
      {
        name: 'Dr. Shushrutha KS',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2021/comsoc/shushrutha_sir.jpg',
      },
      {
        name: 'Anushka Subramanian',
        position: 'Chair',
        image: imagePath + '/alumni/2021/comsoc/anushka.jpg',
      },
      {
        name: 'Saraansh Agarwal',
        position: 'Secretary',
        image: imagePath + '/alumni/2021/comsoc/saraansh.jpg',
      },
      {
        name: 'Shreehitha MU',
        position: 'Treasurer',
        image: imagePath + '/alumni/2021/comsoc/shreehitha.jpg',
      },
    ],
    2020: [
      {
        name: 'Kashish Malhotra',
        position: 'Chair',
        image: imagePath + '/alumni/2020/comsoc/kashish.jpg',
      },
      {
        name: 'Nandesh Goudar',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2020/comsoc/nandesh.jpg',
      },
      {
        name: 'Saraansh Agarwal',
        position: 'Secretary',
        image: imagePath + '/alumni/2020/comsoc/saraansh.jpg',
      },
    ],
    2019: [{ name: 'Trilok Girish', position: 'Chair' }],
  },
  pes: {
    2025: [
      {
        name: 'Prof. SG Srivani',
        position: 'Faculty Advisor',
        image: 'https://rvce.rveducationalinstitutions.com/department/wp-content/uploads/2025/07/SRIVANI-1-scaled.jpg',
      },
      {
        name: 'Kumari Anjali',
        position: 'Chair',
        image: imagePath + '/alumni/2025/pes/Chair.jpg',
      },
      {
        name: 'Ranjit Kumar Ramoji ',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2025/pes/Ranjit_Kumar_Ramoji.png',
      },
      {
        name: 'Nishant V H',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/pes/Nishant_V_H.png',
      },
      {
        name: 'Vedant',
        position: 'Joint Secretary',
        image: imagePath + '/alumni/2025/pes/Vedant.jpg',
      },
      {
        name: 'Aryan B Naik',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/pes/Aryan_B_Naik.png',
      },
    ],
    2024: [
      {
        name: 'Prof. SG Srivani',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/pes/srivani_maam.jpg',
      },
      {
        name: 'Vijay Kiran U R',
        position: 'Chair',
        image: imagePath + '/alumni/2024/pes/VIJAY KIRAN U R _chair.jpg',
      },
      {
        name: 'Ishan Varun',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/pes/ishan varun(Secretary).jpg',
      },
      {
        name: 'Laxmi',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/pes/Laxmi_Treasurer.jpg',
      },
    ],
    2023: [
      {
        name: 'Prof. SG Srivani',
        position: 'Faculty Advisor',
        image: imagePath + '/execom/pes/srivani_maam.jpg',
      },
      {
        name: 'Punith R C',
        position: 'Chair',
        image: imagePath + '/execom/pes/punith_r_c.JPG',
      },
      {
        name: 'Pragya Singh',
        position: 'Secretary',
        image: imagePath + '/execom/pes/pragya_singh.png',
      },
      {
        name: 'Nitin S',
        position: 'Treasurer',
        image: imagePath + '/execom/pes/nitin_s.jpg',
      },
    ],
    2022: [
      {
        name: 'Prof. SG Srivani',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2022/pes/srivani_maam.jpg',
      },
      {
        name: 'Vansh Nandwana',
        position: 'Chair',
        image: imagePath + '/alumni/2022/pes/Vansh_Nandwan.jpeg',
      },
      {
        name: 'Aviral Srivastava',
        position: 'Treasurer',
        image: imagePath + '/alumni/2022/pes/Aviral_Shrivastav.jpeg',
      },
    ],
    2021: [
      {
        name: 'Prof. SG Srivani',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2021/pes/srivani_maam.jpg',
      },
      {
        name: 'Shreyas Sharma',
        position: 'Chair',
        image: imagePath + '/alumni/2021/pes/shreyas.jpg',
      },
      {
        name: 'Hariharasudhan J',
        position: 'Secretary',
        image: imagePath + '/alumni/2021/pes/hari.jpg',
      },
      {
        name: 'Shirish Kumar',
        position: 'Treasurer',
        image: imagePath + '/alumni/2021/pes/shirish.jpg',
      },
    ],
    2020: [
      {
        name: 'Amith S Kumar',
        position: 'Chair',
        image: imagePath + '/alumni/2020/pes/amith.jpg',
      },
      {
        name: 'Deeraj DS',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2020/pes/deeraj.jpg',
      },
      {
        name: 'Hariharasudhan J',
        position: 'Secretary',
        image: imagePath + '/alumni/2020/pes/hari.jpg',
      },
      {
        name: 'Shirish Kumar',
        position: 'Treasurer',
        image: imagePath + '/alumni/2020/pes/shirish.jpg',
      },
    ],
    2019: [
      { name: 'Shravan Sridhar', position: 'Chair' },
      { name: 'Aayush Mohanty', position: 'Vice Chair' },
      { name: 'Anand Raj', position: 'Secretary' },

      { name: 'Shresth Rahul', position: 'Treasurer' },
      { name: 'Anvit Garg', position: 'Webmaster' },
    ],
  },
  sps: {
    2025: [
      {
        name: 'Dr. Saraswathi',
        position: 'Faculty Advisor',
        image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/SARASWATHI-K-1-scaled.jpg',
      },
      {
        name: 'Shamanth Raj E',
        position: 'Chair',
        image: imagePath + '/alumni/2025/sps/Shamanth Raj E (Chair).png',
      },
      {
        name: 'M Barath',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/sps/M Barath (Secretary).jpg',
      },
      {
        name: 'Sreesha K R',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/sps/Sreesha K R (Treasurer).jpg',
      },
    ],
    2024: [
      {
        name: 'Prof. K Nagamani',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/sps/nagamani_maam.jpg',
      },
      {
        name: 'Yuvraj Singh',
        position: 'Chair',
        image: imagePath + '/alumni/2024/sps/Yuvraj Singh - SPS CHAIR.JPG',
      },
      {
        name: 'Atharva',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/sps/Atharva _SPS_Sec.jpg',
      },
      {
        name: 'Ayush Raj',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/sps/Ayush_Raj_SPS_Treasurer.jpg',
      },
    ],
    2023: [
      {
        name: 'Prof. K Nagamani',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2022/sps/nagamani_maam.jpg',
      },
      {
        name: 'Chirag C Rao',
        position: 'Chair',
        image: imagePath + '/alumni/2023/sps/Avaneeth_Anil.jpeg',
      },
      {
        name: 'Mustafa Chikhliwala',
        position: 'Secretary',
        image: imagePath + '/alumni/2023/sps/Atul_Sai.jpeg',
      },
      {
        name: 'Rajeev Singh',
        position: 'Treasurer',
        image: imagePath + '/alumni/2023/sps/Rajeev_Singh.jpeg',
      },
    ],
    2022: [
      {
        name: 'Prof. K Nagamani',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2022/sps/nagamani_maam.jpg',
      },
      {
        name: 'Avaneeth Anil',
        position: 'Chair',
        image: imagePath + '/alumni/2022/sps/Avaneeth_Anil.jpeg',
      },
      {
        name: 'Atul Sai',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2022/sps/Atul_Sai.jpeg',
      },
      {
        name: 'Ananya Dhulipala',
        position: 'Treasurer',
        image: imagePath + '/alumni/2022/sps/Ananya_D.jpeg',
      },
    ],
    2021: [
      {
        name: 'Prof. K Nagamani',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2021/sps/nagamani_maam.jpg',
      },
      {
        name: 'Niranjan DR',
        position: 'Chair',
        image: imagePath + '/alumni/2021/sps/niranjan.jpg',
      },
      {
        name: 'R Vibha Narayan',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2021/sps/vibha.jpg',
      },
      {
        name: 'Saksham Sharma',
        position: 'Treasurer',
        image: imagePath + '/alumni/2021/sps/saksham.jpg',
      },
    ],
    2020: [
      {
        name: 'Prof. K Nagamani',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2020/sps/nagamani_maam.jpg',
      },
      {
        name: 'Niranjan DR',
        position: 'Chair',
        image: imagePath + '/alumni/2020/sps/niranjan.jpg',
      },
      {
        name: 'R Vibha Narayan',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2020/sps/vibha.jpg',
      },
      // {name: 'Rahul Ratnu Chavan', position: 'Secretary', image: imagePath + '/alumni/2020/sps/rahulrc.jpg'},
      // {name: 'Dhanush U', position: 'Treasurer', image: imagePath + '/alumni/2020/sps/dhanush.jpg'},
    ],
  },
  wie: {
    2025: [
      {
        name: 'Dr. Sahana B',
        position: 'Faculty Advisor',
        image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/SAHANA-B-1-scaled.jpg',
      },
      {
        name: 'Tanisha Dey',
        position: 'Chair',
        image: imagePath + '/alumni/2025/wie/Tanisha Dey -Chair.jpg',
      },
      {
        name: 'Saneha Sharma',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/wie/Saneha Sharma.jpg',
      },
      {
        name: 'Spandana KN',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/wie/Spandana KN - Treasurer.jpg',
      },
    ],
    2024: [
      {
        name: 'Prof Deepika',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/wie/deepika_maam.jpg',
      },
      {
        name: 'Anisha Bhattacharya',
        position: 'Chair',
        image: imagePath + '/alumni/2024/wie/Anisha Bhattacharya -  Chair.JPG',
      },
      {
        name: 'Swara Gingade',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/wie/Swara Gingade- Secretary .HEIC',
      },
      {
        name: 'Tanmaya WM',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/wie/Tanmaya WM - Treasurer .jpeg',
      },
    ],
    2023: [
      {
        name: 'Prof Deepika',
        position: 'Faculty Advisor',
        image: imagePath + '/execom/wie/deepika_maam.jpg',
      },
      {
        name: 'Jahnavi M Math',
        position: 'Chair',
        image: imagePath + '/alumni/2023/wie/jahnavi_m_math.jpg',
      },
      {
        name: 'Omisha Singh',
        position: 'Secretary',
        image: imagePath + '/alumni/2023/wie/omisha_singh.jpg',
      },
      {
        name: 'Gohitha Maheshwari J',
        position: 'Treasurer',
        image: imagePath + '/alumni/2023/wie/gohitha_maheshwari.jpg',
      },
    ],
    2022: [
      {
        name: 'Dr. Usha Rani K R',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2022/wie/usha_maam.jpg',
      },
      {
        name: 'Anagha Anand',
        position: 'Chair',
        image: imagePath + '/alumni/2022/wie/Anagha_Anand.jpeg',
      },
      {
        name: 'Neha N',
        position: 'Secretary',
        image: imagePath + '/alumni/2022/wie/neha.jpeg',
      },
      {
        name: 'Nisarga V',
        position: 'Treasurer',
        image: imagePath + '/alumni/2022/wie/Nisarga.jpg',
      },
    ],
    2021: [
      {
        name: 'Dr. Usha Rani K R',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2021/wie/usha_maam.jpg',
      },
      {
        name: 'Sreelakshmi',
        position: 'Chair',
        image: imagePath + '/alumni/2021/wie/sreelakshmi.jpg',
      },
      {
        name: 'Sunidhi Salwadgi',
        position: 'Secretary',
        image: imagePath + '/alumni/2021/wie/sunidhi.jpg',
      },
    ],
    2020: [
      {
        name: 'Dr. Usha Rani K R',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2020/wie/usha_maam.jpg',
      },
      {
        name: 'Aisiri HR',
        position: 'Chair',
        image: imagePath + '/alumni/2020/wie/aisiri.jpg',
      },
      {
        name: 'Raghavi R',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2020/wie/raghavi.jpg',
      },
      {
        name: 'Sreelakshmi',
        position: 'Secretary',
        image: imagePath + '/alumni/2020/wie/sreelakshmi.jpg',
      },
      {
        name: 'Sunidhi Salwadgi',
        position: 'Treasurer',
        image: imagePath + '/alumni/2020/wie/sunidhi.jpg',
      },
    ],
    2019: [
      { name: 'Disha Gulur', position: 'Chair' },
      { name: 'Shravanti K Ramesh', position: 'Vice Chair' },
    ],
  },
  ras: {
    2025: [
      {
        name: 'Dr. Geetha KS',
        position: 'Faculty Advisor',
        image: 'https://rvce.edu.in/department/wp-content/uploads/2025/07/Vice-Principal-1-scaled.jpg',
      },
      {
        name: 'Smriti V Soolebhavi',
        position: 'Chair',
        image: imagePath + '/alumni/2025/ras/Smriti V Soolebhavi - CHAIR .jpg',
      },
      {
        name: 'Veethi',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/ras/Veethi - Secretary .jpg',
      },
      {
        name: 'Sudhanshu H',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/ras/Sudhanshu H -Treasurer(RAS).jpeg',
      },
    ],
    2024: [
      {
        name: 'Dr. Geetha KS',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/ras/geetha_maam.jpeg',
      },
      {
        name: 'Sanjay S',
        position: 'Chair',
        image: imagePath + '/alumni/2024/ras/Sanjay S Chair.jpg',
      },
      {
        name: 'Bhaskar Jha',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/ras/Bhaskar Jha Secretary .jpg',
      },
      {
        name: 'Balasai Anish Ponnaluri',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/ras/Balasai Anish Ponnaluri-Treasurer .jpg',
      },
    ],
    2023: [
      {
        name: 'Dr. Abhay Deshpande',
        position: 'Faculty Advisor',
        image: imagePath + '/execom/ras/abhay_a_deshpande.jpg',
      },
      {
        name: 'Shreya Sakri',
        position: 'Chair',
        image: imagePath + '/execom/ras/shreya_sakri.jpeg',
      },
      {
        name: 'S Lingeshwara',
        position: 'Secretary',
        image: imagePath + '/execom/ras/s_lingeshwara.jpg',
      },
      {
        name: 'S Vedram',
        position: 'Treasurer',
        image: imagePath + '/execom/ras/s_vedram.png',
      },
    ],
    2022: [
      {
        name: 'Dr. Geetha K S',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2022/ras/geetha_maam.jpg',
      },
      {
        name: 'Saksham Sharma',
        position: 'Chair',
        image: imagePath + '/alumni/2022/ras/saksham.jpg',
      },
      {
        name: 'Shreya Sakri',
        position: 'Secretary',
        image: imagePath + '/alumni/2022/ras/shreya_sakri.jpeg',
      },
      {
        name: 'Suraj Ponnanna K C',
        position: 'Treasurer',
        image: imagePath + '/alumni/2022/ras/suraj.jpeg',
      },
    ],
    2021: [
      {
        name: 'Dr. Geetha K S',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2021/ras/geetha_maam.jpg',
      },
      {
        name: 'Naman A Menezes',
        position: 'Chair',
        image: imagePath + '/alumni/2021/ras/naman.jpg',
      },
      {
        name: 'Ambu Karthik',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2021/ras/ambu.jpg',
      },
      {
        name: 'Rahul Pinny',
        position: 'Secretary',
        image: imagePath + '/alumni/2021/ras/pinny.jpg',
      },
      {
        name: 'Rithwik Jayanth',
        position: 'Treasurer',
        image: imagePath + '/alumni/2021/ras/rithwik.jpg',
      },
    ],
  },
  sight: {
    2025: [
      {
        name: 'Dr Usha J',
        position: 'Faculty Advisor',
        image: 'https://rvce.rveducationalinstitutions.com/department/wp-content/uploads/2025/07/USHA-J-1-scaled.jpg',
      },
      {
        name: 'Prarthana R',
        position: 'Chair',
        image: imagePath + '/alumni/2025/sight/Prarthana R.jpg',
      },
      {
        name: 'Vinay Sinnur',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/sight/Vinay Sinnur.jpg',
      },
      {
        name: 'Yashmitha Desai',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/sight/Yashmitha Desai.jpeg',
      },
    ],
    2024: [
      {
        name: 'Dr Usha J',
        position: 'Faculty Advisor',
        image: 'https://rvce.rveducationalinstitutions.com/department/wp-content/uploads/2025/07/USHA-J-1-scaled.jpg',
      },
      {
        name: 'Arya Vinod',
        position: 'Chair',
        image: imagePath + '/execom/sight/lalith_kishore.jpg',
      },
      {
        name: 'Goutami Sooda',
        position: 'Secretary',
        image: imagePath + '/execom/sight/nandan_chebbi.jpg',
      },
      {
        name: 'N Ragavenderan',
        position: 'Treasurer',
        image: imagePath + '/execom/sight/neha_p.jpg',
      },
    ],
    2023: [
      {
        name: 'Dr Usha J',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2023/sight/usha_maam.jpg',
      },
      {
        name: 'Lalith K',
        position: 'Chair',
        image: imagePath + '/alumni/2023/sight/lalith_kishore.jpg',
      },
      {
        name: 'Nandan Chebbi',
        position: 'Secretary',
        image: imagePath + '/alumni/2023/sight/nandan_chebbi.jpg',
      },
      {
        name: 'Neha P',
        position: 'Treasurer',
        image: imagePath + '/alumni/2023/sight/neha_p.jpg',
      },
    ],
    2022: [
      {
        name: 'Dr Usha J',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2022/sight/usha_maam.jpg',
      },
      {
        name: 'Samhitha S',
        position: 'Chair',
        image: imagePath + '/alumni/2022/sight/samhitha.jpg',
      },
      {
        name: 'Neha N',
        position: 'Secretary',
        image: imagePath + '/alumni/2022/sight/neha.jpeg',
      },
      {
        name: 'Nisarga V',
        position: 'Treasurer',
        image: imagePath + '/alumni/2022/sight/Nisarga.jpg',
      },
    ],
    2021: [
      {
        name: 'Dr Usha J',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2021/sight/usha_maam.jpg',
      },
    ],
  },
  cas: {
    2025: [
      {
        name: 'Dr.N.Ramavenkateswaran',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/cas/Dr N Ramavenkateswaran.jpeg',
      },
      {
        name: 'Shravan V',
        position: 'Chair',
        image: imagePath + '/alumni/2025/cas/Shravan V Chair (CASS).jpg',
      },
      {
        name: 'Suryansh Tripathi',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2025/cas/Suryansh Tripathi Vice Chair (CASS).jpg',
      },
      {
        name: 'Shreekara H',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/cas/Shreekara H. Secretary (CASS).jpg',
      },
      {
        name: 'Tharun Reddy',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/cas/Tharun Reddy treasurer(CASS).jpg',
      },
    ],
    2024: [
      {
        name: 'Dr.N.Ramavenkateswaran',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/cas/Dr N Ramavenkateswaran.jpeg',
      },
      {
        name: 'Pratham G',
        position: 'Chair',
        image: imagePath + '/alumni/2024/cas/PrathamG-Chair.jpg',
      },
      {
        name: 'Kamath Abhay Sunil',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2024/cas/Kamath Abhay Sunil Vice Chair.jpg',
      },
      {
        name: 'Dhtuthi MD',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/cas/Dhtuthi_MD-secretary_CAS.jpg',
      },
      {
        name: 'Paridhi Sudarshan',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/cas/Paridhi Sudarshan-Treasurer.jpg',
      },
    ],
    2023: [
      {
        name: 'Dr. Shylashree.N ', //needs to be updated
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/cas/dr_shylashree.jpeg',
      },
      {
        name: 'Akash Kotagi',
        position: 'Chair',
        image: imagePath + '/alumni/2023/cas/akash_kotagi.jpg',
      },
      {
        name: 'Sanjana Carol',
        position: 'Secretary',
        image: imagePath + '/alumni/2023/cas/sanjana_carol.jpg',
      },
      {
        name: 'Sai Surya Sreekar Mulukutla',
        position: 'Treasurer',
        image: imagePath + '/alumni/2023/cas/sreekar_mulukutla.jpg',
      },
    ],
    2022: [
      {
        name: 'Dr. Shylashree N',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2022/cas/dr_shylashree.jpeg', //to be updated
      },
      {
        name: 'Keerthana Ramesh ',
        position: 'Chair',
        image: imagePath + '/alumni/2022/cas/keerthana.jpeg',
      },
      {
        name: 'Sriniketh S S',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2022/cas/sriniketh.jpg',
      },
      {
        name: 'Akash Kotagi',
        position: 'Secretary',
        image: imagePath + '/alumni/2022/cas/akash.jpeg',
      },
      {
        name: 'Ritesh Gandhi',
        position: 'Treasurer',
        image: imagePath + '/alumni/2022/cas/ritesh.jpeg',
      },
    ],
  },
  sc: {
    2025: [
      {
        name: 'Dr. Ravishankar Holla',
        position: 'Faculty Advisor',
        image: '',
      },
      {
        name: 'Aditya Balan',
        position: 'Chair',
        image: imagePath + '/alumni/2025/sensorscouncil/Chair-Aditya Balan.jpg',
      },
      {
        name: 'Krishna Purwar',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/sensorscouncil/Secretary - Krishna Purwar.jpg',
      },
      {
        name: 'Muhammad Ammar Siddiqui',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/sensorscouncil/Treasurer - Muhammad Ammar Siddiqui_.jpg',
      },
    ],
    2024: [
      {
        name: 'Dr. Veena Divya K',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/sensorscouncil/veena_maam.jpg',
      },
      {
        name: 'Bhavik Bafna ',
        position: 'Chair',
        image: imagePath + '/alumni/2024/sensorscouncil/Bhavik Bafna - Chair.JPG',
      },
      {
        name: 'Ashray A Pai',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/sensorscouncil/Ashray A Pai- Secretory.JPG',
      },
      {
        name: 'Shikhar Verma',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/sensorscouncil/Shikhar Verma-Treasurer.jpg',
      },
    ],
  },
  aess: {
    2025: [
      {
        name: 'Dr. K S Shushrutha',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/aess/drksshushrutha.png',
      },
      {
        name: 'Gagana Y',
        position: 'Chair',
        image: imagePath + '/alumni/2025/aess/Gagana Y - Chair.jpg',
      },
      {
        name: 'Samany S',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2025/aess/Samany S - Vice Chair.jpg',
      },
      {
        name: 'Aditi A',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/aess/Aditi A - Secretary_.jpg',
      },
      {
        name: 'Lishika U',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/aess/Lishika U - Treasurer.jpg',
      },
    ],
    2024: [
      {
        name: 'Dr. K S Shushrutha',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/aess/drksshushrutha.png',
      },
      {
        name: 'Vishal Hugar ',
        position: 'Chair',
        image: imagePath + '/alumni/2024/aess/Vishal Hugar - Chair.jpeg',
      },
      {
        name: 'Deepika ',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2024/aess/Deepika- Vice chair.jpg',
      },
      {
        name: 'Om Daxini',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/aess/Om Daxini - Secratary.jpg',
      },
      {
        name: 'Pratik B Matt',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/aess/Pratik_B_Matt_-_Treasurer_.jpg',
      },
    ],
  },
  mtts: {
    2025: [
      {
        name: 'Dr. Mahesh A',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/mtts/drmahesh.jpg',
      },
      {
        name: 'Yashasvi Jana',
        position: 'Chair',
        image: imagePath + '/alumni/2025/mtts/Yashasvi Jana - Chair_.jpg',
      },
      {
        name: 'Vipul Joshi',
        position: 'Vice Chair',
        image: imagePath + '/alumni/2025/mtts/Vipul Joshi - Vice Chair.jpeg',
      },
      {
        name: 'Tanmay Joshi',
        position: 'Secretary',
        image: imagePath + '/alumni/2025/mtts/Tanmay Joshi- Secretary.jpg',
      },
      {
        name: 'Harshith B',
        position: 'Treasurer',
        image: imagePath + '/alumni/2025/mtts/Harshith B- Treasurer.jpg',
      },
    ],
    2024: [
      {
        name: 'Dr. Mahesh A',
        position: 'Faculty Advisor',
        image: imagePath + '/alumni/2024/mtts/drmahesh.jpg',
      },
      {
        name: 'Yasha Mandawat ',
        position: 'Chair',
        image: imagePath + '/alumni/2024/mtts/MTT_Chair_Yasha Mandawat.jpg',
      },
      {
        name: 'Yashasvi Jana',
        position: 'Secretary',
        image: imagePath + '/alumni/2024/mtts/YashasviJana - MTTS_Secretary .jpg',
      },
      {
        name: 'Ananya Bhat',
        position: 'Treasurer',
        image: imagePath + '/alumni/2024/mtts/MTTS_Treasurer_AnanyaRBhat.jpg',
      },
    ],
  },
  cs: {
    2022: [], //to be added
  },
};

export const about = {
  img1: imgify`history/1.png`,
  img2: imgify`history/2.png`,
};
export { achievements as FPAchievementImages, whatWeDo as FPWhatWeDoImages } from './data/FrontPage/Carousels';
export { whatWeDoText, SbachievementsText } from './data/FrontPage/Text';
export { imagePath, hostname };
